import { IComboBoxOption } from "@fluentui/react";
import { DataType } from "../../types";
import Entity from "./Entity";
import { IAttributeSchema } from "./IAttributeSchema";

export interface IJSAttributeProps {
    schema: IAttributeSchema;
    entity: Entity;
}

export default class Attribute {

    #props: IJSAttributeProps;
    #relatedEntity: Entity = null;

    constructor(props: IJSAttributeProps) {
        this.#props = props;
    }

    get id(): string {
        return this.#props.schema.id;
    }

    get code(): string {
        return this.#props.schema.code;
    }

    get name(): string {
        return this.#props.schema.name;
    }

    get dataType(): DataType {
        return this.#props.schema.dataType;
    }

    get isPrimaryKey(): boolean {
        return this.#props.schema.isPrimaryKey
            ?? this.#props.schema.code === 'Id'
            ?? false;
    }

    get relatedEntityId(): string {
        return this.#props.schema.relatedEntityId;
    }

    get relatedEntity(): Entity {
        if (this.#relatedEntity == null && this.relatedEntityId != null)
            this.#relatedEntity = this.#props.entity.project.findEntity(this.relatedEntityId);
        return this.#relatedEntity;
    }

    get fluentUi(): IComboBoxOption {
        return {
            key: this.#props.schema.id,
            text: `${this.name} (${this.code})`
        }
    }

    get description(): string {
        return this.#props.schema.description || '';
    }

    get enabled(): boolean {
        return this.#props.schema.enabled || false;
    }

    get entity(): Entity {
        return this.#props.entity;
    }

    get maxLength(): number {
        return this.#props.schema.maxLength;
    }

    public getSchema(): IAttributeSchema {
        return this.#props.schema;
    }

}